import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import FreemiumEventPurchase from './FreemiumEventPurchase';
import withModal from '../../../../components/global/modal/withModal';
import DismissButton from '../../../../components/global/DismissButton';
import { getAsset } from '../../../../util/assets';
import { FREEMIUM_EVENTS_META } from './helpers';

export const FREEMIUM_EVENT_PURCHASE_MODAL = 'modal/FREEMIUM_EVENT_PURCHASE';

const propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  actionProps: PropTypes.shape({
    eventType: PropTypes.string,
    onConfirmSelection: PropTypes.func,
  }),
};

const FreemiumEventPurchaseModal = ({
  onRequestClose,
  actionProps: { eventType, onConfirmSelection } = {},
  albumSubType: albumSubTypeProp,
  ...props
}) => {
  const albumSubtype = albumSubTypeProp ?? eventType;
  const meta = FREEMIUM_EVENTS_META[albumSubtype];

  return (
    <Fragment>
      <DismissButton
        onClick={onRequestClose}
        className="freemium-event-purchase-dismiss"
      />
      <img
        src={getAsset(meta.icon)}
        alt="Let's get your event going"
        width="48"
        className="mx-auto mb-2 d-flex"
      />
      <h1 className="text-extra-bold mb-2 text-center">{meta.title}</h1>
      <p className="text-center mb-5">
        Everyone&apos;s photos &amp; videos in one easily shared
        Waldo&ndash;fied album.
      </p>

      <FreemiumEventPurchase
        albumSubtype={albumSubtype}
        onConfirmSelection={onConfirmSelection}
        {...props}
      />
    </Fragment>
  );
};

FreemiumEventPurchaseModal.propTypes = propTypes;

export default withModal(FreemiumEventPurchaseModal, {
  name: FREEMIUM_EVENT_PURCHASE_MODAL,
  className: 'freemium-event-purchase-modal',
  overlayClassName: 'freemium-event-purchase-modal-overlay',
  size: 'lg',
  type: 'full',
  dismissible: false,
});
